<template>
  <v-app>
    <v-app-bar
      app
      color="background"
    >
      <div class="d-flex align-center">
        <router-link to="/"> 
          <v-btn fab>
            <v-icon>
              mdi-tennis
            </v-icon>
          </v-btn>
        </router-link> 
        <v-spacer/>Dash Score
      </div>

      <v-spacer></v-spacer>
      <router-link to="/login"> 
        <v-btn rounded color="secondary">
        <v-icon>mdi-account</v-icon>
        <v-spacer></v-spacer>
        Login
        </v-btn>
      </router-link>
    </v-app-bar>

    <v-content>
      <router-view/>
    </v-content>

    <v-footer
        absolute
        class="font-weight-medium"
        color="background"
      >
     
        <v-col
          class="text-center"
          cols="12"
        >      <v-img
          alt="Aperio Logo"
          class="shrink mr-2"
          contain
          src="./assets/AperioLogo.png"
          transition="scale-transition"
          width="40"
          to="Home"
        /> 

          <v-spacer></v-spacer>
          (c)
          {{ new Date().getFullYear() }} — <strong>Aperio</strong>
          <v-spacer></v-spacer>
        </v-col>
      </v-footer>
  </v-app>
</template>

<script>
// import Home from './components/Home';

export default {
  name: 'App',

  components: {
    // Home,
  },

  data: () => ({
    //
  }),
};
</script>
